var r = /* @__PURE__ */ ((e) => (e.Create = "create", e.SignIn = "signin", e))(r || {});
export {
  r as SignInDialog
};
//# sourceMappingURL=index.js.map
